import { SiteUrls } from '@tableau/shared-urls';
import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { cssClass } from '../../style';
import { IDataSourceBase } from '../../ts/models/IDataSourceInfo';
import { DataSources } from '../../ts/resources/Datasources';
import { boldClass, sectionTitleClass } from '../styles/DefinitionSubspaceSharedStyles';
import { getFriendlyDataType } from '../utils/contentMaps';
import { ConstDataRoleDescriptorBlock } from './ConstantDataRoleDescriptorBlock';

export interface DefinitionSubspaceAboutSectionProps {
  readonly dataTypes: ReadonlyArray<String>;
  readonly datasource?: IDataSourceBase;
  readonly sourceField?: string;
  readonly siteUrls: SiteUrls;
  readonly description?: string;
}

const cssPrefix = 'DefinitionSubspaceAboutSection';
const topRowClass = cssClass(cssPrefix, 'topRow', {display: 'flex', flexWrap: 'wrap'});
const dsIconClass = cssClass(cssPrefix, 'dsIcon', {verticalAlign: 'middle'});

const sourceFieldClass = cssClass(cssPrefix, 'sourceField', {
  color: TabStyles.Typography.Color.Secondary,
  fontSize: TabStyles.Typography.Sizing.Small,
});

export const DefinitionSubspaceAboutSection: React.StatelessComponent<DefinitionSubspaceAboutSectionProps> = (props: DefinitionSubspaceAboutSectionProps) => {
  return <React.Fragment>
    <div className={sectionTitleClass}>{Messages.dataRoleDefinitionSubspace_About_Title()}</div>
    <div className={topRowClass} >
      <ConstDataRoleDescriptorBlock
        title={Messages.dataRoleDefinitionSubspace_About_RoleType()}
        content={Messages.dataRoleDefinitionSubspace_About_RoleType_Dictionary()}/>
      <ConstDataRoleDescriptorBlock
        title={Messages.dataRoleDefinitionSubspace_About_DataType()}
        content={props.dataTypes.map(getFriendlyDataType).join(', ')}/>
      {
        props.datasource ?
        <ConstDataRoleDescriptorBlock
          title={Messages.dataRoleDefinitionSubspace_About_DataSource()}
          content={getDatasourceLink(props.datasource, props.siteUrls, props.sourceField)}/> : null
      }
    </div>
    {
      props.description && props.description.length > 0 ?  // Show Description block only if it is nonempty
      <ConstDataRoleDescriptorBlock
        title={Messages.dataRoleDefinitionSubspace_About_Description()}
        content={props.description}/> : null
    }
  </React.Fragment>;
};

const getDatasourceLink = (ds: IDataSourceBase, urls: SiteUrls, sourceField: string | undefined): JSX.Element => (
  <>
    <div>
      <img src={DataSources.getIconForDatasourceType(ds, 'medium')} className={dsIconClass}/>
      <a href={urls.datasourceDetailsUrl(ds.id)}>{ds.name}</a>
    </div>
    {sourceField ? <div className={sourceFieldClass}>
      {Messages.dataRoleDefinitionSubspace_About_SourceField()} <span className={boldClass}>{sourceField}</span>
    </div> : null}
  </>
);
